var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.621 15.804C4.71942 14.6179 7.08958 13.9963 9.5 14C12 14 14.347 14.655 16.379 15.804M12.5 8C12.5 8.79565 12.1839 9.55871 11.6213 10.1213C11.0587 10.6839 10.2956 11 9.5 11C8.70435 11 7.94129 10.6839 7.37868 10.1213C6.81607 9.55871 6.5 8.79565 6.5 8C6.5 7.20435 6.81607 6.44129 7.37868 5.87868C7.94129 5.31607 8.70435 5 9.5 5C10.2956 5 11.0587 5.31607 11.6213 5.87868C12.1839 6.44129 12.5 7.20435 12.5 8ZM18.5 10C18.5 11.1819 18.2672 12.3522 17.8149 13.4442C17.3626 14.5361 16.6997 15.5282 15.864 16.364C15.0282 17.1997 14.0361 17.8626 12.9442 18.3149C11.8522 18.7672 10.6819 19 9.5 19C8.3181 19 7.14778 18.7672 6.05585 18.3149C4.96392 17.8626 3.97177 17.1997 3.13604 16.364C2.30031 15.5282 1.63738 14.5361 1.18508 13.4442C0.732792 12.3522 0.5 11.1819 0.5 10C0.5 7.61305 1.44821 5.32387 3.13604 3.63604C4.82387 1.94821 7.11305 1 9.5 1C11.8869 1 14.1761 1.94821 15.864 3.63604C17.5518 5.32387 18.5 7.61305 18.5 10Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobProfile);
export default __webpack_public_path__ + "static/media/mob_profile.59171342cfae5e5bcd7db4cabdf0a71a.svg";
export { ForwardRef as ReactComponent };